var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.errors)?_c('div',{staticClass:"errors"},[_c('ol',_vm._l((_vm.$parent.errors),function(error,field){return _c('li',{key:field},[_vm._v("\n      "+_vm._s(error[0])+"\n    ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }